import { HttpHeaders, HttpParams } from '@angular/common/http';
import { FlagsApiResponseOfNull, Null  } from '@benefitsui/app/api/benefits-clients';

export type HttpOptions = {
  headers?: HttpHeaders | { [header: string]: string | string[] };
  observe?: 'body';
  params?: HttpParams | { [param: string]: string | string[] };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  customHandling?: CustomHandlingOptions;
};

export const PolicyTokenHeaderName = 'x-policy-token';

export interface ApiResponse<T extends Null> extends FlagsApiResponseOfNull {
  data: T;
}

export interface Message {
  id: string;
  body: string;
  severity: 'Info' | 'Warn' | 'Error';
  context: { [key: string]: string };
}

export type CustomHandlingOptions = {
  bypassAuthenticationRedirect?: boolean;
  bypassErrorPageRedirect?: boolean;
};
